export const schema = {
  type: "object",
  properties: {
    oportunityname: { type: "string" },
    accountname: { type: "string" },
    closedate: { type: "string" },
    amount: { type: "string" },
    description: { type: "string" },
    oportunityowner: { type: "string" },
    stage: { type: "string" },
    probability: { type: "string" },
    forecastcategory: { type: "string" },
    nextstep: { type: "string" },
  },
};
